module.exports = __webpack_public_path__ + "np.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/np.svg
// module id = 737
// module chunks = 0